import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { globalVariablesServer } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private headers: HttpHeaders;
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT"

    });
  }


  UpdateProfile(paramdata) {
    return this.http.post(globalVariablesServer.apiurl + 'api/ApiAppUsers/UpdateProfile', paramdata, { headers: this.headers });
  }


}
